module.exports = __webpack_public_path__ + "img/fenliaojiance.a71686a8.svg";